<template>
  <div class="group relative h-full f-col overflow-hidden" :class="bgClass">
    <base-button
      v-if="quickshop"
      :aria-describedby="product.id"
      :aria-label="$t.add"
      class="absolute right-0 top-0 z-3 p-1 group-@hover:op-100 duration lg:op-0 group-focus-within:lg:op-100"
      data-test-id="product-card-add"
      style="margin-right: 0.125rem"
      @click="handleQuickshop($event)"
    >
      <span class="m-1 block rounded-xs duration">
        <vf-icon name="quickshop" size="md" />
      </span>
    </base-button>
    <base-picture
      v-bind="size"
      :alt="image.alt"
      class="w-full overflow-hidden"
      :props-img="{ class: 'duration-800 group-hover:scale-105' }"
      :src="getResponsiveImageTransformations(image.src, {
        ...size,
        ...transformations,
      })"
    />
    <div v-style:c="textColor" class="px-2 pb-4 pt-3 lg:p-4">
      <base-link
        :id
        class="line-clamp-4 w-fit subtitle-6"
        :to="{
          path: url,
          state: searchType ? { category: `Search: ${searchType}`, searchType, suggestedPhrase } : {},
        }"
        @click="handleClick"
      >
        {{ title }}
        <span class="absolute-0" />
      </base-link>
      <product-pricing
        class="body-5"
        :currency
        :price
        :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
        style="margin-top: 0.375rem"
      />
    </div>

    <panel-quickshop v-slot="props" class-wrapper="!p-0" :size="{ sm: 'lg', lg: 'full' }" :title="$t.size">
      <dialog-quickshop v-bind="props" :product-id="product.id" />
    </panel-quickshop>
  </div>
</template>

<script lang="ts" setup>
import type { RecommendationStyle } from '#content/contexts/recommendation'
import type { ProductVariants } from '#root/api/clients/product/data-contracts'
import type { ProductCardRecommendedProps } from '#types/components/cms/product-card-recommended'
import type { HistoryState } from 'vue-router'
import { RecommendationStyleContextKey } from '#content/contexts/recommendation'

const {
  currency,
  gtmConfig,
  id,
  image,
  price,
  quickshop = true,
  title,
  url,
  variant,
} = defineProps<ProductCardRecommendedProps>()

const emit = defineEmits<{ 'product-click': [e: PointerEvent] }>()

const route = useRoute()

const searchType = inject('searchType', undefined) as HistoryState | undefined
const suggestedPhrase = inject('suggestedPhrase', undefined) as HistoryState | undefined

const product = computed(() => ({
  id,
  name: title,
  url,
  price,
  currency,
  attributes: [],
  variants: {} as ProductVariants
}))

const closeQuickshopOnAdd = route.name?.toString().includes('cart')

const { size: imageSizeMap, transformations } = useAppConfig().components.cms.productRecommendations.presets

const size = imageSizeMap[variant]

const PanelQuickshop = createPanel('quickshop')

const { textColor, whiteBackground } = inject(RecommendationStyleContextKey, {} as RecommendationStyle)

const bgClass = whiteBackground === false ? '' : 'bg-white'

const handleClick = (e: PointerEvent) => {
  setInteractionOrigin('search', true)
  emit('product-click', e)
}

const handleQuickshop = (e: PointerEvent) => {
  emit('product-click', e)
  PanelQuickshop.keep().open({
    product: product.value,
    closeOnAdd: closeQuickshopOnAdd,
    gtmConfig,
    variant: 'detailed'
  })
}
</script>
